import React from 'react'

function Skills() {
    return (
        <>
            {/* # */}
            <section className="skill section" id="skill" aria-label="skill">
                <div className="container" style={{ marginTop: '15px' }}>
                    <h2 className="headline headline-2 section-title" id="tag-label">
                        <span className="span">My Skills / Knowledge</span>
                    </h2>
                    <p className="section-text">
                        Prabhjeet Singh is a versatile professional with expertise in Web Development, Graphics Designing, SEO,
                        Photography, and
                        Video Editing. He excels in Data Analysis and Team Collaboration, complemented by skills in Digital
                        Marketing,
                        Leadership, and effective Communication. His Marketing Expertise and Brand Making abilities further enhance
                        his
                        capabilities, making him a valuable asset for modern, multifaceted projects.
                    </p>
                    <ul className="grid-list">
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-code" />
                                <p className="btn-text">Web Development</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-paint-brush" />
                                <p className="btn-text">Graphics Designing</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-chart-line" />
                                <p className="btn-text">SEO</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-camera" />
                                <p className="btn-text">Photography</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-video" />
                                <p className="btn-text">Cinematography</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-video" />
                                <p className="btn-text">Video Editing</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-paint-roller" />
                                <p className="btn-text">UI/UX Designing</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-chart-bar" />
                                <p className="btn-text">Data Analysis</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-users" />
                                <p className="btn-text">Team Collaboration</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-globe" />
                                <p className="btn-text">Digital Marketing</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-film" />
                                <p className="btn-text">Film Making</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-people-arrows" />
                                <p className="btn-text">Leadership Qualities</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-rocket" />
                                <p className="btn-text">VFX</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-comments" />
                                <p className="btn-text">Communication Skills</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-flag" />
                                <p className="btn-text">Brand Making</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-chart-pie" />
                                <p className="btn-text">Marketing Expertise</p>
                            </button>
                        </li>
                        <li>
                            <button className="card tag-btn">
                                <i className="fas fa-film" />
                                <p className="btn-text">Animation</p>
                            </button>
                        </li>
                    </ul>
                </div>
            </section>

        </>
    )
}

export default Skills